export default __webpack_public_path__ + "dc109f8fb9bcc9e02315e91acda0145f.svg";